<template>
  <div>
    <v-app-bar>
      <div class="menu-logo">
        <img
          height="30x"
          alt="Skala Logo"
          class="float-left"
          :src="require('@/assets/img/logo.png')"
        />
      </div>
      <div class="float-left ml-2">
        <h3>{{ $t("regDis.title") }}</h3>
        <div class="subtitle">
          {{ $t("regDis.subtitle") }}
        </div>
      </div>

      <v-toolbar-title class="ml-6" v-text="title" />
    </v-app-bar>

    <v-stepper v-model="e1">
      <v-stepper-header>
        <v-stepper-step :complete="e1 > 1" step="1">
          {{ $t("regDis.steps.gdpr") }}
        </v-stepper-step>

        <v-divider></v-divider>
        <v-stepper-step :complete="e1 > 2" step="2">
          {{ $t("regDis.steps.divi") }}
        </v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step :complete="e1 > 3" step="3">
          {{ $t("regDis.steps.comp") }}
        </v-stepper-step>
        <v-divider></v-divider>

        <v-stepper-step step="4">
          {{ $t("regDis.steps.contact") }}
        </v-stepper-step>
      </v-stepper-header>

      <v-stepper-items>
        <v-stepper-content step="1">
          <h1>{{ $t("regDis.step_gdpr.title") }}</h1>
          <v-card flat class="mb-12 pa-6" color="grey lighten-3">{{
            $t("regDis.step_gdpr.info")
          }}</v-card>

          <v-row justify="center">
            <v-btn color="primary" @click="(e1 = 2), (agree = true)">
              {{ $t("regDis.agree") }}
            </v-btn>

            <v-btn to="/" text> {{ $t("regDis.cancel") }} </v-btn>
          </v-row>
        </v-stepper-content>

        <v-stepper-content step="2">
          <v-row justify="center">
            <v-col xl="6" md="6" class="pa-12">
              <h1>{{ $t("regDis.step_divi.title") }}</h1>
              <v-select
                v-model="divisions"
                :items="divize"
                attach
                item-text="text"
                item-value="value"
                chips
                :label="$t('regDis.step_divi.select')"
                multiple
                filled
              ></v-select>
            </v-col>
          </v-row>

          <v-row justify="center">
            <v-btn color="primary" @click="e1 = 3">
              {{ $t("regDis.next") }}
            </v-btn>

            <v-btn to="/" text> {{ $t("regDis.cancel") }} </v-btn>
          </v-row>
        </v-stepper-content>

        <v-stepper-content step="3">
          <v-row justify="center">
            <v-col xl="6" md="6" class="">
              <h1>{{ $t("regDis.step_comp.title") }}</h1>
              <v-text-field
                v-model="companyTitle"
                :rules="rules"
                counter="50"
                :label="$t('regDis.step_comp.name')"
                name="companyName"
                filled
              ></v-text-field>
              <v-text-field
                v-model="companyICO"
                :rules="rules"
                counter="50"
                hint=""
                :label="$t('regDis.step_comp.ico')"
                name="ico"
                filled
              ></v-text-field>
              <v-text-field
              v-if="$i18n.locale != 'ru'"
                v-model="companyDIC"
                :rules="rules"
                counter="50"
                hint=""
                :label="$t('regDis.step_comp.dic')"
                name="dic"
                filled
              ></v-text-field>
              <v-select
                v-model="kvalitaRizeni"
                :items="kvalita"
                item-text="text"
                item-value="value"
                :label="$t('regDis.step_comp.quality')"
                filled
              ></v-select>
              <v-select
                v-model="verejneZakazky"
                :items="zakazky"
                item-text="text"
                item-value="value"
                :label="$t('regDis.step_comp.procurement')"
                filled
              ></v-select>
              <v-text-field
                v-model="www"
                :rules="rules"
                counter="50"
                hint=""
                :label="$t('regDis.step_comp.www')"
                name="www"
                filled
              ></v-text-field>
              <v-textarea
                v-model="impresum"
                :rules="rules250"
                counter="250"
                hint=""
                :label="$t('regDis.step_comp.impresum')"
                name="impresum"
                filled
              ></v-textarea>
            </v-col>
          </v-row>

          <v-row justify="center">
            <v-btn color="primary" @click="e1 = 4">
              {{ $t("regDis.next") }}
            </v-btn>

            <v-btn to="/" text> {{ $t("regDis.cancel") }} </v-btn>
          </v-row>
        </v-stepper-content>
        <v-stepper-content step="4">
          <v-row justify="center">
            <v-col xl="6" md="6" class="">
              <h1>{{ $t("regDis.step_contact.title") }}</h1>
              <v-text-field
                v-model="name"
                :rules="rules"
                counter="50"
                :label="$t('regDis.step_contact.name')"
                name="name"
                filled
              ></v-text-field>
              <v-text-field
                v-model="surname"
                :rules="rules"
                counter="50"
                :label="$t('regDis.step_contact.surname')"
                name="surname"
                filled
              ></v-text-field>
              <v-text-field
                v-model="email"
                :rules="rules"
                counter="50"
                hint=""
                :label="$t('regDis.step_contact.email')"
                name="email"
                filled
              ></v-text-field>
              <v-text-field
                v-model="phone"
                :rules="rules"
                counter="50"
                hint=""
                :label="$t('regDis.step_contact.phone')"
                name="phone"
                filled
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row justify="center">
            <v-btn color="primary" @click="sendData">
              {{ $t("regDis.send") }}
            </v-btn>

            <v-btn to="/" text> {{ $t("regDis.cancel") }} </v-btn>
          </v-row>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
    <v-overlay :value="overlay">
      <v-progress-circular
        v-if="!sendSuccess && !sendError"
        indeterminate
        size="64"
      ></v-progress-circular>

      <v-alert v-if="sendSuccess" elevation="1" prominent type="success"
        ><h2>{{ $t("regDis.sendSuccessTitle") }}</h2>
        {{ $t("regDis.sendSuccessInfo") }}
        <div>
          {{ $t("regDis.sendSign") }}
        </div>
      </v-alert>
      <v-alert v-if="sendError" elevation="1" prominent type="error"
        ><h2>{{ $t("regDis.sendErrorTitle") }}</h2>
        {{ $t("regDis.sendErrorInfo") }}
        <div>
          {{ $t("regDis.sendSign") }}
        </div>
        <v-btn color="primary" @click="closeModal">
              {{ $t("regDis.ok") }}
        </v-btn>
      </v-alert>
    </v-overlay>
  </div>
</template>
<script>
export default {
  data() {
    return {
      overlay: false,
      sendSuccess: false,
      sendError: false,
      e1: 1,
      agree: false,
      divize: [
        { value: "tactical", text: this.$t("regDis.step_divi.divis")[0] },
        { value: "surgery", text: this.$t("regDis.step_divi.divis")[1] },
      ],
      kvalita: [
        { value: "none", text: this.$t("regDis.step_comp.qualitySelect")[0] },
        {
          value: "ISO9001",
          text: this.$t("regDis.step_comp.qualitySelect")[1],
        },
        {
          value: "ISO13485",
          text: this.$t("regDis.step_comp.qualitySelect")[2],
        },
        { value: "other", text: this.$t("regDis.step_comp.qualitySelect")[3] },
      ],
      zakazky: [
        { value: true, text: this.$t("regDis.bool")[0] },
        { value: false, text: this.$t("regDis.bool")[1] },
      ],
      rules: [(v) => v.length <= 50 || this.$t("regDis.max50")],
      rules250: [(v) => v.length <= 250 || this.$t("regDis.max250")],
      impresum: "",
      personName: "",
      surname: "",
      email: "",
      iso: "",
      phone: "",
      companyICO: "",
      companyDIC: "",
      www: "",
      divisions: [],
      verejneZakazky: "",
      kvalitaRizeni: "",
    };
  },
  mounted(){
    if(this.$route.query.lang){
     // this.$i18n.locale = this.$route.query.lang
    }
  },
  methods: {
    closeModal(){
      this.overlay = false;
      this.sendError = false;
    },
    sendData() {
      this.overlay = true;
      var reqData = {
        companyName: this.companyTitle,
        ico: this.companyICO,
        dic: this.companyDIC,
        email: this.email,
        phone: this.phone,
        divisions: this.divisions,
        name: this.name,
        surname: this.surname,
        www: this.www,
        gdpr: this.agree,
        verejneZakazky: this.verejneZakazky,
        kvalitaRizeni: this.kvalitaRizeni,
      };
      this.$http
        .post(this.$store.state.apiServer + "add/distributorrequest", reqData)
        .then(() => {
          setTimeout(() => {
            this.sendSuccess = true;
            setTimeout(() => {
              this.$router.push("/");
            }, 3000);
          }, 1000);
        })
        .catch(() => {
          this.sendError = true;
        });
    },
  },
};
</script>
<style scoped>
.menu-logo {
  margin: 10px 0 0 10px;
}
h3 {
  font-size: 16px;
  margin: 0px !important;
  padding: 0px !important;
}
.subtitle {
  font-size: 8px;
  margin-top: -5px;
}
</style>